import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class MerchantMakePayment extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

        var request_data = JSON.stringify({
            "fieldData": {
                "BankAccountNumber": "1019001500100970",
                "BankBranchCode": "CNRB0000232",
                "ReceiverFirstName": "Karam",
                "ReceiverLastName": "jeet",
                "receiverAddress": "Chandigarh",
                "receiverState": "chd",
                "receiverCity": "CHD",
                "receiverPostalCode": "151001",
                "receiverEmail": "karam@gmail.com",
                "receiverContactNumber": "09876543210",
                "receiverDateOfBirth": "2004-11-11",
                "senderSourceOfFund": "Salary",
                "relationship": "Father",
                "purposeOfPayment": "Business Profits to Parents",
                "subPurposeOfPayment": ""
            },
            "receiver_amount": "85.36",
            "sender_amount": "1.22",
            "currrates": "69.9683",
            "fees": "0.000",
            "locationId": "AU SMALL FINANCE BANK LIMITED",
            "service_name": "AU SMALL FINANCE BANK LIMITED",
            "receiverPaymentType": "individual",
            "corridor": "bank",
            "session_id": "SESS_IK1WFQ5DH260CC584GH10B0XVF8R8U49",
            "payment_type": "wallet or card", // wallet or card
            "nonce": "a7f92c1d8e4b6f3a9c5d7e1f2b8a4c6d",
            "device_type": "web - Windows - Chrome - 147.0.0.0",
            "senderDetails": {
                "first_name": "sachin",
                "last_name": "rana",
                "mobile_no": "8954133055",
                "email": "sachin@gmail.com",
                "address": "sre",
                "city": "sre",
                "postal": "247122",
                "iso_country_code": "AU",
                "idExpiry": "2028-01-10",
                "idNumber": "213124124",
                "idType": "DRIVERS",
                "idDob": "2000-01-10",
                "idCountry": "AU"
            }
        }, null, 2);
        var card_response_data = JSON.stringify({
            "data": {
              "link": "https://staging-merchant.e-pocket.com/pay/DIIV21N4",
              "expire_time": "2026-08-06 08:04:51"
            },
            "success": true,
            "message": "The transaction link has been created. Please use the link to complete the payment."
          }, null, 2);

        var response_data = JSON.stringify({
            "success": true,
            "data": {
                "id": "TPEP000001938178",
                "amount": "85.36",
                "conversion_rate": "69.9683",
                "status": "success"
            },
            "message": "Your money is being processed."
        }, null, 2);
      
        var error_response = JSON.stringify({
            "success": false,
            "message": "Invalid Session"
        }, null, 2);
        
        var pending_response = JSON.stringify({
            "success": false,
            "data": {
                "id": "",
                "amount": "93.70",
                "status": "pending"
            },
            "message": "Error in transaction"
        }, null, 2);

        var fx_rate_change_response = JSON.stringify({
            "success": false,
            "message": "The exchange rate has changed since your initial selection...",
            "is_fx_change": true,
            "data": {
                "sender_amount": 1.22,
                "amount": "84.38",
                "conversion_rate": "69.1641",
                "org_conversion_rate": "66.7607",
                "popup_title": "The exchange rate has changed",
                "popup_data": [
                    {
                        "label": "Initial exchange rate",
                        "value": "1 AUD = 70.0543 INR"
                    },
                    {
                        "label": "New exchange rate",
                        "value": "1 AUD = 69.1641 INR"
                    },
                    {
                        "label": "Our fee",
                        "value": "0.000 AUD"
                    },
                    {
                        "label": "Total to pay",
                        "value": "1.22 AUD"
                    },
                    {
                        "label": "Recipient gets",
                        "value": "84.38 INR"
                    }
                ]
            }
        }, null, 2);

        const copyClipboard = (e,data) => {
            console.log('copyClipboard');
            e.preventDefault();
            navigator.clipboard.writeText(data);
            toast.success('Data copied !', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        };

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                        <article class="docs-article" id="section-1">
                        <h1 class="docs-heading">Make Payment</h1>
                        <section class="docs-intro">

                            <p>
                            Creates and submits a remittance transaction for processing.
                            </p>

                            <p>
                            This is the final API in the transaction flow. It requires all information collected from previous APIs including exchange-rate values, payout institution, beneficiary details, sender identification, and branch code (when applicable).
                            </p>

                            <p>
                            All preceding steps must be completed before calling this API:
                            </p>

                            <ul>

                                <li>Corridor selection</li>

                                <li>Exchange-rate calculation</li>

                                <li>Payout institution selection</li>

                                <li>Recipient form collection</li>

                                <li>Branch code retrieval (if applicable)</li>

                            </ul>

                            <p>
                                The transaction ID returned by this API must be stored immediately and used for transaction tracking, reconciliation, and status retrieval.
                            </p>

                            </section>
                        </article>

                        <article class="docs-article" id="section-2">
                            <header class="docs-header">
                                <h1 class="docs-heading">
                                    Make Payment Reference
                                </h1>
                                <section class="docs-intro row">
                                    <div class="col-lg-6 col-12">
                                    <p>
                                        This POST API creates and submits a remittance transaction using all data collected throughout the transaction flow.
                                    </p>
                                    <div class="alert alert-info mt-3">
                                    <b>When to Use</b>
                                        <p class="mb-0">
                                            Call this API after collecting all beneficiary details and completing all required validation checks.
                                        </p>
                                    </div>
                                    <section class="docs-section row" id="item-2-3">
                                        <h2 class="section-heading">Api Params</h2>

                                        <div class="col-lg-6 col-12">

                                            {/* Request Attributes */}
                                            <div class="attributes">
                                                <div class="attributes-head">
                                                    <h4>Request Attributes</h4>
                                                </div>

                                                <div class="attributes-contents">

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">fieldData</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">Object</span><br />
                                                        Contains all beneficiary details returned by the
                                                        <b> Get Recipient Form</b> API.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">senderDetails</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">Object</span><br />
                                                        Contains sender information including personal details and identification.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">receiver_amount</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Beneficiary receiving amount from the Calculate Exchange Rates API.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">sender_amount</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Sender payment amount returned by the Calculate Exchange Rates API.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">currrates</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Exchange rate returned by the Calculate Exchange Rates API.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">fees</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Transaction fee returned by the Calculate Exchange Rates API.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">corridor</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Selected payout corridor.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">locationId</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Selected payout institution.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">service_name</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Selected payout institution name.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">payment_type</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Allowed values:
                                                        <span class="highlight"> wallet </span> /
                                                        <span class="highlight"> card </span>.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">receiverPaymentType</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Receiver type (e.g. individual).
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">session_id</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Transaction session ID.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">nonce</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Unique 32-character request identifier.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">device_type</span>
                                                    </div>
                                                    <p>
                                                        Type : <span class="highlight">String</span><br />
                                                        Device information.
                                                    </p>

                                                </div>
                                            </div>

                                            {/* Response Parameters */}
                                            <div class="attributes">
                                                <div class="attributes-head">
                                                    <h4>Response Parameters</h4>
                                                </div>

                                                <div class="attributes-contents">

                                                    <p>
                                                        <b>Wallet Payment Response</b>
                                                    </p>

                                                    <p>
                                                        <b>id</b> :
                                                        <span class="highlight"> String</span><br />

                                                        <b>amount</b> :
                                                        <span class="highlight"> String</span><br />

                                                        <b>conversion_rate</b> :
                                                        <span class="highlight"> String</span><br />

                                                        <b>status</b> :
                                                        <span class="highlight"> String</span>
                                                    </p>

                                                    <hr />

                                                    <p>
                                                        <b>Card Payment Response</b>
                                                    </p>

                                                    <p>
                                                        <b>link</b> :
                                                        <span class="highlight"> String</span><br />

                                                        <b>expire_time</b> :
                                                        <span class="highlight"> String</span>
                                                    </p>

                                                </div>
                                            </div>

                                        </div>
                                    </section>


                                    </div>
                                    <div class="col-lg-6 col-12 mr-4">
                                        <div class="copybox mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">Api Endpoint</p>
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code class="copybox-code">
                                                        Method : POST <br />
                                                        &nbsp;Endpoint: /v2/merchant/make-payment
                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                        <div class="copybox mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">PRE-REQUEST API KEY</p>
                                                <svg style={{cursor: "pointer"}}
                                                onClick={(e) => {
                                                    copyClipboard(e, request_data);
                                                 }}
                                                    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                        fill="#7281B8" />
                                                </svg>
                                                {/* <span class="highlight copied-msg">text copied</span> */}
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code class="copybox-code">
                                                        {request_data}

                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                        <div class="copybox copybox-response mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">RESPONSE (Wallet Payment)</p>
                                                <svg 
                                                style={{cursor: "pointer"}}
                                                onClick={(e) => {
                                                    copyClipboard(e, response_data);
                                                 }} 
                                                 width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                        fill="#7281B8"
                                                    />
                                                </svg>
                                                {/* <span class="highlight copied-msg">text copied</span> */}
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code id="copy-txt" class="copybox-code ">
                                                        {response_data}
                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                        <div class="copybox copybox-response mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">RESPONSE (Card Payment)</p>
                                                <svg 
                                                style={{cursor: "pointer"}}
                                                onClick={(e) => {
                                                    copyClipboard(e, card_response_data);
                                                 }} 
                                                 width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                        fill="#7281B8"
                                                    />
                                                </svg>
                                                {/* <span class="highlight copied-msg">text copied</span> */}
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code id="copy-txt" class="copybox-code ">
                                                        {card_response_data}
                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                    </div>
                                </section>


                            </header>

                        </article>
                        
                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">Nonce Validation</h2>

                                <table class="table table-bordered table-white">

                                    <thead>
                                        <tr>
                                            <th>Rule</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td>Unique Value</td>
                                            <td>
                                                Nonce must be unique for every request.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Fixed Length</td>
                                            <td>
                                                Nonce must be exactly <code>32</code> characters long.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Generation</td>
                                            <td>
                                                Generate a random alphanumeric value for each request.
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    A — Beneficiary (fieldData) Parameters
                                </h2>

                                <table class="table table-bordered table-white">

                                    <thead>
                                        <tr>
                                            <th>Key</th>
                                            <th>Example Value</th>
                                            <th>Type</th>
                                            <th>Description</th>
                                            <th>Source</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td>BankAccountNumber</td>
                                            <td>353453465636</td>
                                            <td>String</td>
                                            <td>Beneficiary Bank Account Number</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>BankBranchCode</td>
                                            <td>ABHY0065202</td>
                                            <td>String</td>
                                            <td>Selected Branch Code</td>
                                            <td>Get Branch Codes</td>
                                        </tr>

                                        <tr>
                                            <td>accountName</td>
                                            <td>Karamjeet</td>
                                            <td>String</td>
                                            <td>Account Holder Name</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>ReceiverFirstName</td>
                                            <td>Karamjeet</td>
                                            <td>String</td>
                                            <td>Beneficiary First Name</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>ReceiverLastName</td>
                                            <td>Kaur</td>
                                            <td>String</td>
                                            <td>Beneficiary Last Name</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>receiverEmail</td>
                                            <td>karamjeet@e-pocket.com.au</td>
                                            <td>String</td>
                                            <td>Beneficiary Email Address</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>receiverCity</td>
                                            <td>CHD</td>
                                            <td>String</td>
                                            <td>Beneficiary City</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>receiverAddress</td>
                                            <td>Chandigarh</td>
                                            <td>String</td>
                                            <td>Beneficiary Address</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>receiverPostalCode</td>
                                            <td>151001</td>
                                            <td>String</td>
                                            <td>Beneficiary Postal Code</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>receiverContactNumber</td>
                                            <td>09876543210</td>
                                            <td>String</td>
                                            <td>Beneficiary Mobile Number</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>receiverDateOfBirth</td>
                                            <td>2001-11-11</td>
                                            <td>String</td>
                                            <td>Beneficiary Date of Birth</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>purposeOfPayment</td>
                                            <td>Family</td>
                                            <td>String</td>
                                            <td>Purpose of Transfer</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                        <tr>
                                            <td>subPurposeOfPayment</td>
                                            <td>""</td>
                                            <td>String</td>
                                            <td>Sub Purpose of Transfer</td>
                                            <td>Get Recipient Form</td>
                                        </tr>

                                    </tbody>

                                </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    B — Transaction Parameters
                                </h2>

                                <table class="table table-bordered table-white">

                                    <thead>
                                        <tr>
                                            <th>Key</th>
                                            <th>Example Value</th>
                                            <th>Type</th>
                                            <th>Description</th>
                                            <th>Source</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td>receiver_amount</td>
                                            <td>"121.75"</td>
                                            <td>String</td>
                                            <td>Amount received by beneficiary</td>
                                            <td>Calculate Exchange Rates</td>
                                        </tr>

                                        <tr>
                                            <td>sender_amount</td>
                                            <td>"2"</td>
                                            <td>String</td>
                                            <td>Amount paid by sender</td>
                                            <td>Calculate Exchange Rates</td>
                                        </tr>

                                        <tr>
                                            <td>currrates</td>
                                            <td>"60.8753"</td>
                                            <td>String</td>
                                            <td>Exchange Rate</td>
                                            <td>Calculate Exchange Rates</td>
                                        </tr>

                                        <tr>
                                            <td>fees</td>
                                            <td>"0.000"</td>
                                            <td>String</td>
                                            <td>Transaction Fee</td>
                                            <td>Calculate Exchange Rates</td>
                                        </tr>

                                        <tr>
                                            <td>fixed_side</td>
                                            <td>sender</td>
                                            <td>String</td>
                                            <td>Calculation Basis</td>
                                            <td>Calculate Exchange Rates</td>
                                        </tr>

                                        <tr>
                                            <td>corridor</td>
                                            <td>bank</td>
                                            <td>String</td>
                                            <td>Selected Payout Corridor</td>
                                            <td>Get Available Corridors</td>
                                        </tr>

                                        <tr>
                                            <td>session_id</td>
                                            <td>SESS_XXXX</td>
                                            <td>String</td>
                                            <td>Transaction Session Identifier</td>
                                            <td>Get Available Corridors</td>
                                        </tr>

                                        <tr>
                                            <td>locationId</td>
                                            <td>ABHYUDAYA COOPERATIVE BANK</td>
                                            <td>String</td>
                                            <td>Selected Institution Identifier</td>
                                            <td>Get Payout List</td>
                                        </tr>

                                        <tr>
                                            <td>service_name</td>
                                            <td>ABHYUDAYA COOPERATIVE BANK</td>
                                            <td>String</td>
                                            <td>Institution Name</td>
                                            <td>Get Payout List</td>
                                        </tr>

                                        <tr>
                                            <td>payment_type</td>
                                            <td>wallet or card</td>
                                            <td>String</td>
                                            <td>Specifies the payment funding method. wallet processes the payment immediately. card generates a secure payment link for card payment.</td>
                                            <td>System Configuration</td>
                                        </tr>

                                        <tr>
                                            <td>receiverPaymentType</td>
                                            <td>individual</td>
                                            <td>String</td>
                                            <td>Receiver Type</td>
                                            <td>System Configuration</td>
                                        </tr>

                                        <tr>
                                            <td>nonce</td>
                                            <td>a7f92c1d8e4b6f3a9c5d7e1f2b8a4c6d</td>
                                            <td>String</td>
                                            <td>Unique Request Identifier</td>
                                            <td>System Generated</td>
                                        </tr>

                                        <tr>
                                            <td>device_type</td>
                                            <td>web - Windows - Chrome</td>
                                            <td>String</td>
                                            <td>Device Information</td>
                                            <td>System Generated</td>
                                        </tr>

                                    </tbody>

                                </table>

                            </section>
                        </article>
                        <section class="docs-section row" id="item-2-4">
                            <h2 class="section-heading">Payment Type Behaviour</h2>

                            <div class="col-lg-12 col-12">
                                <div class="attributes">

                                    <div style={{color: "#ebebeb"}}>
                                        <p>
                                            The behavior of the <span class="highlight">Make Payment</span> API depends on the value of
                                            <span class="highlight"> payment_type</span>.
                                        </p>
                                    </div>

                                    <div class="attributes-contents" style={{ width: "100%" }}>
                                        <table class="table table-bordered table-white">
                                            <thead>
                                                <tr>
                                                    <th>payment_type</th>
                                                    <th>Behaviour</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span class="highlight">wallet</span>
                                                    </td>
                                                    <td>
                                                        Processes the payment immediately and returns the transaction result.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span class="highlight">card</span>
                                                    </td>
                                                    <td>
                                                        Creates a secure payment link that the customer must open to complete the payment using a credit or debit card.
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </section>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    C — Sender Details Parameters (senderDetails)
                                </h2>

                                <table class="table table-bordered table-white">

                                    <thead>
                                        <tr>
                                            <th>Key</th>
                                            <th>Example Value</th>
                                            <th>Type</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr><td>first_name</td><td>sachin</td><td>String</td></tr>
                                        <tr><td>last_name</td><td>rana</td><td>String</td></tr>
                                        <tr><td>mobile_no</td><td>8954133055</td><td>String</td></tr>
                                        <tr><td>email</td><td>sachin@gmail.com</td><td>String</td></tr>
                                        <tr><td>address</td><td>sre</td><td>String</td></tr>
                                        <tr><td>city</td><td>sre</td><td>String</td></tr>
                                        <tr><td>postal</td><td>247122</td><td>String</td></tr>
                                        <tr><td>iso_country_code</td><td>AU</td><td>String</td></tr>
                                        <tr><td>idExpiry</td><td>2028-01-10</td><td>String</td></tr>
                                        <tr><td>idNumber</td><td>213124124</td><td>String</td></tr>
                                        <tr><td>idType</td><td>DRIVERS</td><td>String</td></tr>
                                        <tr><td>idDob</td><td>2000-01-10</td><td>String</td></tr>
                                        <tr><td>idCountry</td><td>AU</td><td>String</td></tr>

                                    </tbody>

                                </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Transaction Status Values
                                </h2>

                                <table class="table table-bordered table-white">

                                    <thead>
                                        <tr>
                                            <th>Status</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td>
                                                <code>pending</code>
                                            </td>
                                            <td>
                                                Transaction Created
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <code>success</code>
                                            </td>
                                            <td>
                                                Transaction Completed Successfully
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <code>failed</code>
                                            </td>
                                            <td>
                                                Transaction Failed
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Business Rules
                                </h2>

                                <table class="table table-bordered table-white">

                                    <thead>
                                        <tr>
                                            <th>Rule</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td>Amount Consistency</td>
                                            <td>
                                                <code>sender_amount</code>, <code>receiver_amount</code>,
                                                <code>fees</code>, and <code>currrates</code> must exactly
                                                match the values returned by the Calculate Exchange Rates API.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Dynamic Fields</td>
                                            <td>
                                                All <code>fieldData</code> values must come from the
                                                Get Recipient Form API.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Branch Validation</td>
                                            <td>
                                                <code>BankBranchCode</code> must come from the
                                                Get Branch Codes API.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Institution Validation</td>
                                            <td>
                                                <code>locationId</code> must come from the
                                                Get Payout List API.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Session Validation</td>
                                            <td>
                                                The same <code>session_id</code> must be used throughout
                                                the transaction.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Duplicate Transactions</td>
                                            <td>
                                                Duplicate payment requests may be rejected.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Mandatory Fields</td>
                                            <td>
                                                All required recipient fields must be supplied before
                                                submitting the payment request.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Nonce Validation</td>
                                            <td>
                                                The <code>nonce</code> must be unique for every request
                                                and must be exactly <code>32</code> characters long.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Wallet Payment</td>
                                            <td>
                                                Returns the transaction result immediately. 
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Card Payment</td>
                                            <td>
                                            Returns a secure payment link instead of the transaction result. 
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Payment Link </td>
                                            <td>
                                            The payment link must be presented to the customer before expire_time. 
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Transaction Status </td>
                                            <td>
                                            For card payments, retrieve the final transaction status using the Get Transaction Detail API after the customer completes payment.
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </section>
                        </article>                      

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">Comments</h2>

                                <ul>

                                    <li>Do not modify exchange-rate values returned by Calculate Exchange Rates.</li>

                                    <li>Use the same session_id generated by Get Available Corridors.</li>

                                    <li>If subPurposeOfPayment is returned dynamically, it must be submitted.</li>

                                    <li>Store the transaction ID returned by this API.</li>

                                    <li>A successful Make Payment request invalidates the session_id.</li>

                                    <li>For payment_type = wallet, the transaction is processed immediately. </li>
                                    <li>For payment_type = card, the API returns a secure payment link.</li>
                                    <li> The payment link must be presented to the customer to complete the payment using a credit or debit card.</li>
                                    <li> The payment link expires at expire_time.</li>
                                    <li>  After the customer completes card payment, use the Get Transaction Detail API to retrieve the final transaction status.</li>

                                </ul>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Error Response
                                </h2>

                                <div class="copybox copybox-response">

                                    <div class="copybox-top">

                                        <p class="copybox-para">
                                            ERROR RESPONSE
                                        </p>

                                        <svg
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                                copyClipboard(e, error_response);
                                            }}
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                fill="#7281B8"
                                            />
                                        </svg>

                                    </div>

                                    <div class="copybox-bottom">
                                        <pre>
                                            <code class="copybox-code">
                                                {error_response}
                                            </code>
                                        </pre>
                                    </div>

                                </div>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Common Errors
                                </h2>

                                <table class="table table-bordered table-white">

                                    <thead>
                                        <tr>
                                            <th>Error</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td>Invalid Session</td>
                                            <td>Session expired, invalid, or already used.</td>
                                        </tr>

                                        <tr>
                                            <td>Missing Required Field</td>
                                            <td>Required field not supplied.</td>
                                        </tr>

                                        <tr>
                                            <td>Invalid Branch Code</td>
                                            <td>Branch code is invalid.</td>
                                        </tr>

                                        <tr>
                                            <td>Invalid Location</td>
                                            <td>Institution not supported.</td>
                                        </tr>

                                        <tr>
                                            <td>Invalid Amount</td>
                                            <td>Amount mismatch detected.</td>
                                        </tr>

                                        <tr>
                                            <td>Transaction Failed</td>
                                            <td>The transaction could not be processed.</td>
                                        </tr>

                                    </tbody>

                                </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Pending Response
                                </h2>

                                <div class="copybox copybox-response">

                                    <div class="copybox-top">

                                        <p class="copybox-para">
                                            PENDING RESPONSE
                                        </p>

                                        <svg
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                                copyClipboard(e, pending_response);
                                            }}
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                fill="#7281B8"
                                            />
                                        </svg>

                                    </div>

                                    <div class="copybox-bottom">
                                        <pre>
                                            <code class="copybox-code">
                                                {pending_response}
                                            </code>
                                        </pre>
                                    </div>

                                </div>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Comments
                                </h2>

                                <ul>

                                    <li>
                                        This response indicates that the transaction has been initiated
                                        but is not yet completed.
                                    </li>

                                    <li>
                                        The transaction ID may be empty initially in such cases.
                                    </li>

                                    <li>
                                        Verify the final transaction status using the
                                        <code>Get Transaction Detail</code> API.
                                    </li>

                                    <li>
                                        Do not retry the <code>Make Payment</code> API immediately to
                                        avoid duplicate transactions.
                                    </li>

                                </ul>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    FX Rate Change Response
                                </h2>

                                <div class="copybox copybox-response">

                                    <div class="copybox-top">

                                        <p class="copybox-para">
                                            FX RATE CHANGE RESPONSE
                                        </p>

                                        <svg
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                                copyClipboard(e, fx_rate_change_response);
                                            }}
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                fill="#7281B8"
                                            />
                                        </svg>

                                    </div>

                                    <div class="copybox-bottom">
                                        <pre>
                                            <code class="copybox-code">
                                                {fx_rate_change_response}
                                            </code>
                                        </pre>
                                    </div>

                                </div>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Comments
                                </h2>

                                <ul>

                                    <li>
                                        This is <b>not</b> a transaction failure.
                                    </li>

                                    <li>
                                        It indicates that the exchange rate changed before payment
                                        confirmation.
                                    </li>

                                    <li>
                                        The frontend must display a confirmation popup to the user.
                                    </li>

                                    <li>
                                        The user must accept the updated exchange rate before retrying
                                        the payment.
                                    </li>

                                    <li>
                                        Do <b>not</b> automatically retry the payment without
                                        user confirmation.
                                    </li>

                                    <li>
                                        Display the updated exchange rate and amount only for user
                                        confirmation.
                                    </li>

                                    <li>
                                        The transaction must continue using the original values returned
                                        by the <code>Calculate Exchange Rates</code> API.
                                    </li>

                                    <li>
                                        Any updated exchange rate in this response must
                                        <b> not</b> overwrite the original calculated values.
                                    </li>

                                    <li>
                                        The payment amount must remain exactly the same as returned by
                                        the exchange rate calculation.
                                    </li>

                                </ul>

                            </section>
                        </article>


                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-get-branch-codes"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>&nbsp;
                                                Get Branch Codes
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-get-trans-details"
                                            >
                                                Get Transaction Details&nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}